export default __webpack_public_path__ + "6ad8ddfbf7a05db26c28567d140204dc.png";